import * as React from "react";
import { useAuth } from "../../modules/auth/AuthContext";
import Login from "../../modules/auth/Login";
import { Box, Button, Card, CardContent, CardHeader, CardMedia } from "@mui/material";
import Layout from "../../layout/Layout";
import TemplateLoader from "../../core/TemplateLoader";
import { useMatterSuiteAppQuery } from "../../utils";
import Loading from "../../components/Loading";
import { TimerProvider } from "../../modules/Timer/TimerLoader";
import ComposeMailComponent from "./Compose";
import useConfig from "../../core/useConfig";
import NavbarTimer from "../../modules/Timer/NavbarTimer";
import HomeCarousel from "../../modules/auth/HomeCarousel";
import InboxComponent from "./Inbox";

interface AppProps {}
const LoggedInWrapper = () => {
  const item = Office.context.mailbox.item
  const isCompose = Boolean(item?.body.setSelectedDataAsync) 
  const drawerRef = React.useRef<any>(null);
  const { loading, viewer } = useMatterSuiteAppQuery();
  if (loading) return <Loading />;

  return (
    <TemplateLoader viewer={viewer}>
      <Layout>
        <Box flexGrow={1}>
          Welcome! {viewer?.firstName} {viewer?.lastName}
        </Box>
        <Box flexDirection={"row-reverse"} display={"flex"}>
          <NavbarTimer />
        </Box>
        <Box>
          {
            isCompose ? <ComposeMailComponent /> : <InboxComponent/>
          }
          
        </Box>
      </Layout>
    </TemplateLoader>
  );
};
const App: React.FC<AppProps> = () => {
  Office.context.mailbox.item?.notificationMessages.removeAsync("notif1", (res) => {});
  // console.log("date", Office.context.mailbox.item)

  const { token } = useAuth();
  const LoginTemplate = () => {
    const [showLogin, setShowLogin] = React.useState(false);
    return(
      <Card sx={{ margin: 2, padding: 2 }}>
        <CardMedia
          component="img"
          image="https://storage.googleapis.com/mattersuite-bucket-cdn/logo/auth_logo.svg"
          alt="Paella dish"
          width={"90%"}
        />
        <CardHeader
          title={"Welcome to MatterSuite"}
          subheader={
            "Your all-in-one legal case management solution, designed to streamline your workflow and enhance productivity."
          }
        />
        <CardContent>
          {showLogin ? (
            <Login />
          ) : (
            <HomeCarousel setLogin={setShowLogin} />
          )}
          
        </CardContent>
      </Card>
    )
  };
  if (!token) {
    return <TemplateLoader template={() => <LoginTemplate />} />;
  }
  return <LoggedInWrapper />;
};

export default App;
